export class OpenlrStructure {
  public id: number;
  public siterecordId: number;
  public openlr: string;
}



// WEBPACK FOOTER //
// ./src/app/models/openlrStructure.model.ts